<template>
    <div class="row">
        <div class="alert alert-warning" role="alert" v-for="(alert,index) in validate" :key="index">
            <i data-feather="alert-circle"></i>
            {{alert}}
        </div>

        <barangTable v-show="!isShowForm" @showForm="showForm" :propsData="forms" @deleteBarang="reloadForm"></barangTable>
        <barangForm v-show="isShowForm" @showForm="showTable" :propsData="forms" :propsBarang="barangDetail" :formType="formType" @changeBarang="reloadForm"></barangForm>
    </div>
</template>

<script>
import barangTable from "@/components/exim/ceisa/barang_impor/CeisaBarangTable.vue"
import barangForm from "@/components/exim/ceisa/barang_impor/CeisaBarangForm.vue"
export default {
    name: "CeisaBarangGroup",
    props: {
        propsData: { type: [Object, Array] },
        validate: { type: [Object, Array, String] }
    },
    components: {
        barangTable,
        barangForm
    },
    data() {
        return {
            forms: [],
            isShowForm: false,
            barangDetail:null,
            formType:null,
        }
    },
    methods: {
        showForm(ev,type) {
            console.log(ev,type)
            this.barangDetail = null;
            this.formType = "create";
            if(ev){
                this.formType = type;
                this.barangDetail = ev;
            }
            this.isShowForm = true;
        },
        showTable() {
            this.barangDetail = null;
            this.formType = "create";
            this.isShowForm = false;
        },
        reloadForm(){
            this.$emit("updateData","submitTransaksi");            
            // this.$emit("forceSubmit");
        }
    },
    created() { },
    watch: {
        propsData: function (newVal) {
            this.forms = newVal;
            // this.reAssignValue();

        },
        forms: function (newVal) {
            this.$emit('formUpdate', newVal);
        },
    },
}
</script>

<style></style>